export class TargetProxy {
    constructor(added, removed, updated) {
        this._added = added;
        this._removed = removed;
        this._updated = updated;
    }
    get added() {
        return this._added;
    }
    get removed() {
        return this._removed;
    }
    get updated() {
        return this._updated;
    }
}
//# sourceMappingURL=tiles.pipeline.target.proxy.js.map